import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const API = process.env.REACT_APP_BACKEND_URL;
const STAFF_ROLES = ["super_admin", "admin", "founder", "finance", "teacher", "scolarite", "director", "nurse", "canteen", "staff"];

export default function GoogleAuthCallback() {
  const location = useLocation();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const frag = new URLSearchParams((location.hash || "").replace(/^#/, ""));
    const sessionId = frag.get("session_id");
    if (!sessionId) { setError("Session Google manquante"); return; }
    axios.post(`${API}/api/auth/google/session`, { session_id: sessionId })
      .then(({ data }) => {
        localStorage.setItem("mazid_token", data.access_token);
        localStorage.setItem("mazid_user", JSON.stringify(data.user));
        localStorage.setItem("mazid_portal", STAFF_ROLES.includes(data.user?.role) ? "admin" : "public");
        window.history.replaceState(null, "", "/dashboard");
        window.location.replace("/dashboard");
      })
      .catch((e) => setError(e.response?.data?.detail || "Connexion Google échouée"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0F172A]" data-testid="google-auth-callback">
      <div className="text-center text-white">
        {error ? (
          <>
            <p className="font-semibold text-red-300">{error}</p>
            <a href="/connexion" className="underline text-sm text-slate-300 mt-2 inline-block">Retour à la connexion</a>
          </>
        ) : (
          <>
            <Loader2 className="h-8 w-8 animate-spin mx-auto mb-3 text-[#FBBF24]" />
            <p className="text-sm text-slate-300">Connexion avec Google en cours…</p>
          </>
        )}
      </div>
    </div>
  );
}
